<template lang="pug">
.subscribe-modal
  subscribe-later-modal(v-model="subscribeLater" @continueLater="dialog = false")
  edit-member-modal(v-if="openEditMemberDialog" :open.sync="openEditMemberDialog" :company="company" :count="totalAllowedMember")
  edit-form-modal(v-if="openEditFormDialog" :open.sync="openEditFormDialog" :company="company" :count="totalAllowedForm")
  y-dialog(v-model="dialog" :max-width="step == 0? '400px' : '600px'" persistent scrollable :fullscreen="step == 0? false : $vuetify.breakpoint.xsOnly")
    v-card
      v-card-title.px-4(v-if="company.status != 'Active' && company.contract")
        .h6.textColor--text {{ $t('account_suspended') }}
      v-card-title.px-4(v-else)
        v-layout
          eva-icon.mr-4(v-if="step > 0 && company.status === 'Trial'" name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" @click="dialog = false")
          .h6.textColor--text(v-if="step == 0") {{ windowTitle }}
          .h6.textColor--text(v-else) {{ $t('subscription') }}
      v-card-text.px-4
        y-stepper.mb-8(v-if="step > 0 && step < 5" :currentStep="step" :steps="steps")
        v-window(v-model="step" touchless)
          v-window-item(:value="0")
            div(v-if="authMember.id === company.primary_owner")
              div
                .p1.mb-3 {{ $t('step_0.text_1') }}
                  b.mx-1(v-if="metrics && metrics.all_time >= 0") {{ metrics.all_time | displayPrice }}
                  | {{ $t('step_0.text_2') }}
                .p1.mb-3 {{ $t('step_0.text_3') }}
            div(v-else)
              .p1 {{ $t('step_0.contact_admin') }}
          v-window-item(:value="1")
            //- =========================================================================================================
            //-  1. Choose your plan
            //- =========================================================================================================
            v-layout.pa-6(v-if="!planGroup")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            .contracts(v-else)
              .s2.mt-4 {{ $t('step_1.current_account') }}
              v-row.mt-2(align="center")
                v-col.py-0
                  .p2(:class="isValidMemberCount ? 'primary400--text' : 'danger--text' ") {{ company.active_member_count }} {{ $t('step_1.members') }}
                v-col.shrink.py-0
                  v-btn(v-if="!isValidMemberCount" @click="openEditMemberDialog = true" outlined small :color="$vuetify.theme.themes[$theme].danger" :style="{'background-color': $vuetify.theme.themes[$theme].dangerT08}")
                    .button-AA-tiny.danger500--text {{ $t('step_1.manage_button') }}
              v-row.mt-3(align="center")
                v-col.py-0
                  .p2(:class="isValidFormCount ? 'primary400--text' : 'danger--text' ") {{ company.published_form_count }} {{ $t('step_1.forms') }}
                v-col.shrink.py-0
                  v-btn(v-if="!isValidFormCount" @click="openEditFormDialog = true" outlined small :color="$vuetify.theme.themes[$theme].danger" :style="{'background-color': $vuetify.theme.themes[$theme].dangerT08}")
                    .button-AA-tiny.danger500--text {{ $t('step_1.manage_button') }}

              .main-container.my-6.mx-n4
                v-tabs(v-model="selectedCommitmentType" color="textColorAccent" :height="40" grow)
                  v-tab.button-AA-medium(:style="{ 'color': selectedCommitmentType == 0? $vuetify.theme.themes[$theme].textColorAccent : $vuetify.theme.themes[$theme].basic600 }") {{ $t('step_1.yearly_contract') }}
                  v-tab.button-AA-medium(:style="{ 'color': selectedCommitmentType == 1? $vuetify.theme.themes[$theme].textColorAccent : $vuetify.theme.themes[$theme].basic600 }") {{ $t('step_1.monthly_contract') }}
                div.separator(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")

              v-card.px-4.mb-4.pb-1(v-if="plan.price && plan.price[form.commitment] && plan.price[form.commitment][$currency.code] && plan.value!==4" outlined v-for="(plan, index) in plans" :ripple="false" :key="plan.value" :style="plan.selected ? 'border:2px solid var(--v-textColorAccent)' : 'border:2px solid var(--v-basic300)'" :color="index == recommendedPlanIndex ? $vuetify.theme.themes[$theme].successT08: $vuetify.theme.themes[$theme].basic600T08")
                div.pt-2(@click="selectPlan(plan)")
                  v-row
                    v-col
                      v-layout
                        .h5.textColor--text {{ plan.name }}
                        v-avatar.my-auto.ml-2(v-if="plan.selected" :color='$vuetify.theme.themes[$theme].textColorAccent' size=20)
                          eva-icon(name="checkmark-outline" :fill="$vuetify.theme.themes[$theme].basic100" width="16" height="16" style="margin-top:2px;")
                    v-col
                      .h6.textColorHint--text.text-decoration-line-through.text-right(v-if="plan.slash_price && plan.slash_price[form.commitment] && plan.slash_price[form.commitment][$currency.code]") {{ plan.slash_price[form.commitment][$currency.code] | displayNumberPrice($currency) }}
                      .h4.textColor--text.text-right(v-if="plan.price && plan.price[form.commitment] && plan.price[form.commitment][$currency.code]") {{ plan.price[form.commitment][$currency.code] | displayNumberPrice($currency) }}
                  v-row.mb-3(no-gutters)
                    v-col
                      .p1.primary500--text {{ plan.detail.form }}
                      .p1.primary500--text {{ plan.detail.member }}
                    v-col
                      .p2.primary400--text.text-right {{ $currency.symbol }} per {{ form.commitment === 'yearly' ? 'year' : 'month' }}
                      .s1.success500--text.text-right(v-if="index == recommendedPlanIndex && form.commitment === 'yearly'" ) {{ $t('step_1.yearly_offer') }}
                      .s1.danger500--text.text-right(v-if="index == recommendedPlanIndex && form.commitment === 'monthly'" ) {{ $t('step_1.monthly_offer') }}
                  
                  div.mb-3(v-if="plan.value === 3 ")
                    .p1.success500--text  {{ $t('step_1.follow_up_system') }}
                    .p1.success500--text {{ $t('step_1.agent_commission_system') }}
                    .p1.success500--text {{ $t('step_1.product_bundle_offer') }}

              .s1.mb-2 {{ $t('step_1.add_ons') }}
              v-card.pa-2.mb-4(v-if="selectedPlan" outlined style="border:1px solid var(--v-basic300); border-radius:0")
                v-list-item.px-0.my-n2
                  v-list-item-content(v-if="selectedPlan.addon_price")
                    v-list-item-title.font-weight-bold {{ $t('step_1.form') }}
                    v-list-item-subtitle(v-if="form.commitment ==='monthly'") + {{ `${$currency.symbol} ${$options.filters.displayNumberPrice(selectedPlan.addon_price[form.commitment].form[$currency.code])}` }} {{ $t('step_1.each_month') }}
                    v-list-item-subtitle(v-else) + {{ `${$currency.symbol} ${$options.filters.displayNumberPrice(selectedPlan.addon_price[form.commitment].form[$currency.code])}` }} {{ $t('step_1.each_year') }}
                  v-list-item-action
                    v-layout
                      v-btn.my-auto(icon small @click="formAddOnCount--" :disabled="formAddOnCount < 1")
                        v-icon(color="primary") mdi-minus-circle
                      span.my-auto.text-center.colbox {{ formAddOnCount }}
                      v-btn.my-auto(icon small @click="formAddOnCount++")
                        v-icon(color="primary") mdi-plus-circle
                v-list-item.px-0.my-n2
                  v-list-item-content
                    v-list-item-title.font-weight-bold {{ $t('step_1.salesperson') }}
                    v-list-item-subtitle(v-if="form.commitment ==='monthly'") + {{ `${$currency.symbol} ${$options.filters.displayNumberPrice(selectedPlan.addon_price[form.commitment].member[$currency.code])}` }} {{ $t('step_1.each_month') }}
                    v-list-item-subtitle(v-else) + {{ `${$currency.symbol} ${$options.filters.displayNumberPrice(selectedPlan.addon_price[form.commitment].member[$currency.code])}` }} {{ $t('step_1.each_year') }}
                  v-list-item-action
                    v-layout
                      v-btn.my-auto(icon small @click="memberAddOnCount--" :disabled="memberAddOnCount < 1")
                        v-icon(color="primary") mdi-minus-circle
                      span.my-auto.text-center.colbox {{ memberAddOnCount }}
                      v-btn.my-auto(icon small @click="memberAddOnCount++")
                        v-icon(color="primary") mdi-plus-circle

          v-window-item(:value="2")
            //- =========================================================================================================
            //-  2. Select payment method
            //- =========================================================================================================

            .h5.textColor--text.text-center {{ $t('step_2.select_payment_method') }}
            v-card.mt-8(flat outlined style="border:1px solid var(--v-basic300);")
              v-radio-group.mt-n1(v-model="selectedPaymentMethod" hide-details)
                v-layout(style="cursor: pointer" @click="selectedPaymentMethod = 'card'")
                  v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                    eva-icon.ma-auto(name="credit-card-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                  v-col.pa-0.my-auto
                    v-layout.py-4
                      div.my-auto.pr-2
                        .s1.basic800--text {{ $t('step_2.card') }}
                  v-col.pa-0.shrink.mt-5
                    v-radio.my-0.py-0.mr-2(value="card" readonly)
                v-divider.basic300
                v-layout(:style="(form.commitment === 'monthly' || form.billing_cycle === 'monthly') ? 'cursor: default' : 'cursor: pointer'" @click="(form.commitment === 'monthly' || form.billing_cycle === 'monthly') ? '' : selectedPaymentMethod = 'fpx'")
                  v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                    BuildingBankIcon.ma-auto(size="24" :style="form.commitment === 'yearly' ? 'color: var(--v-basic700)' : 'color: var(--v-basic500)'")
                  v-col.pa-0.my-auto
                    v-layout.py-4
                      div.my-auto.pr-2
                        .s1(:class="form.commitment === 'yearly' ? 'basic800--text' : 'basic500--text' ") {{ $t('step_2.online') }}
                        .c1.basic500--text(v-if="form.commitment === 'monthly'") {{ $t('step_2.yearly_contract') }}
                        .c1.basic500--text(v-if="form.commitment === 'yearly' && form.billing_cycle === 'monthly'") {{ $t('step_2.annual_billing') }}
                  v-col.pa-0.shrink.mt-5
                    v-radio.my-0.py-0.mr-2(value="fpx" readonly)

            v-card.pa-4.mt-8(v-if="selectedPaymentMethod" flat outlined style="border:1px solid var(--v-basic300);")
              card-list.mt-4(v-if="selectedPaymentMethod === 'card'" @change="form.card = $event.id")
              .online-payment.mt-4(v-else-if="selectedPaymentMethod === 'fpx' && company.currency.currency_code === 'MYR'")
                div.subtitle.mb-3 {{ $t('step_2.choose_bank') }}
                v-card.mb-12
                  FPXPicker(v-model="fpxBankCode")
          v-window-item.text-center(:value="3")
            //- =========================================================================================================
            //-  3. Confirm your subscription
            //- =========================================================================================================
            template(v-if="selectedPlan")
              .h5.textColor--text.text-center.mb-8 {{ $t('step_3.confirm_subscribe') }}
              .h3.mt-6.textColor--text {{ selectedPlan.name }} {{ $t('step_3.plan') }}
              .h1.text-center.mt-4 {{ totalPrice | displayNumberPrice }}
                span(v-if="extraPrice")  + {{ extraPrice | displayNumberPrice }}

              .p1.primary400--text.mt-4(v-if="form.commitment === 'monthly'") {{ $currency.symbol }} {{ $t('step_3.price_month') }}
              .p1.primary400--text.mt-4(v-else) {{ $currency.symbol }} {{ $t('step_3.price_year', { text: form.billing_cycle.replace('ly', '') }) }}
              .extra.mt-4
                .s1.textColor--text + {{ selectedPlan.yezza_pay_rate }}% {{ $t('step_3.transacton') }}
                .side(v-if="formAddOnCount || memberAddOnCount")
                  .s1.textColor--text(v-if="formAddOnCount") + {{ formAddOnCount }} {{ $tc('step_3.extra_form', formAddOnCount) }}
                  .s1.textColor--text(v-if="memberAddOnCount") + {{ memberAddOnCount }} {{ $tc('step_3.extra_member', memberAddOnCount) }}
          v-window-item(:value="4")
            //- =========================================================================================================
            //-  4. Thank you
            //- =========================================================================================================
            .h5.textColor--text.mb-8.text-center {{ $t('step_4.subscribe_successful') }}
            v-container.text-center
              .p1.primary400--text {{ $t('step_4.thanks') }}
              .p1.primary400--text.mt-4 {{ $t('step_4.thanks_2') }}
              v-btn.mt-4(color="info500" dark @click="dialog=false" depressed height=32 )
                .button-AA-medium.basic100--text {{ $t('step_4.finish_button') }}
          v-window-item(:value="5")
            //- =========================================================================================================
            //-  4. Payment failed
            //- =========================================================================================================
            .h5.textColor--text.mb-8.text-center {{ $t('step_5.payment_failed') }}
            v-container.text-center
              .p1.primary400--text {{ $t('step_5.try_again') }}
              v-btn.mt-4(color="info500" dark @click="retryPayment" depressed height=32 )
                .button-AA-medium.basic100--text {{ $t('step_5.retry_button') }}

      v-divider.basic300(v-if="step == 1")
      v-card-actions.basic200.px-4(v-if="step == 1")
        v-col.pa-0(v-if="selectedPlan")
          .s2.primary400--text {{ $t('card_actions.selected_plan') }}
          v-layout
            .p2.textColor--text {{ selectedPlan.name }} ({{ form.commitment }} {{ $t('card_actions.contract') }})
            v-spacer
            .p2.textColor--text(v-if="selectedPlan.price && selectedPlan.price[form.commitment]") {{ $currency.symbol }} {{ selectedPlan.price[form.commitment][$currency.code] | displayNumberPrice($currency) }}
          v-layout
            .p2.textColor--text + {{ $t('card_actions.service_fee') }}
            v-spacer
            .p2.textColor--text {{ selectedPlan.yezza_pay_rate }}
          v-layout(v-if="formAddOnCount")
            .p2.textColor--text + {{ formAddOnCount }} {{ $t('card_actions.forms', { text: form.commitment }) }}
            v-spacer
            .p2.textColor--text {{ $currency.symbol }} {{ $options.filters.displayNumberPrice(formAddOnCount * selectedPlan.addon_price[form.commitment].form[$currency.code]) }}
          v-layout(v-if="memberAddOnCount")
            .p2.textColor--text + {{ memberAddOnCount }} {{ $t('card_actions.salespersons', { text: form.commitment }) }}
            v-spacer
            .p2.textColor--text {{ $currency.symbol }} {{ $options.filters.displayNumberPrice(memberAddOnCount * selectedPlan.addon_price[form.commitment].member[$currency.code]) }}
          .p2.danger500--text(v-if="!isValidMemberCount || !isValidFormCount") {{ $t('card_actions.manage_account') }}
      v-divider.basic400(v-if="step == 1")
      v-card-actions.pr-4(v-if="authMember.id === company.primary_owner" :class="step == 1? 'basic200' : ''")
        v-spacer
        template(v-if="step === 0")
          v-btn(color='white' text @click="dialog = false")
            .button-Aa-medium.primary400--text {{ $t('card_actions.subscrbe_later') }}
        v-btn(v-else-if="step !== 4 && step !== 5" color='white' text @click="step--")
          .button-Aa-medium.primary400--text {{ $t('card_actions.back') }}
        template(v-if="step === 2")
          v-btn(v-if="selectedPaymentMethod == 'card'" color="info500" @click="nextStep" depressed :disabled="!form.card" height=32 )
            .button-AA-medium.basic100--text {{ $t('card_actions.next') }}
          v-btn(v-else color="info500" @click="nextStep" depressed :disabled="(!fpxBankCode && company.currency.currency_code === 'MYR') || selectedPaymentMethod !== 'fpx'" height=32 )
            .button-AA-medium.basic100--text {{ $t('card_actions.next') }}
        v-btn(v-else-if="step === 3" @click="nextStep" color="info500" dark depressed :loading="isLoading" height=32 )
          .button-AA-medium.basic100--text {{ $t('card_actions.confirm_pay') }}
        div(v-else-if="step === 4")
        div(v-else-if="step === 5")
        v-btn(v-else color="info500" dark @click="nextStep" depressed height=32 )
          .button-AA-medium.basic100--text {{ $t('card_actions.next') }}
      v-card-actions(v-else)
        v-spacer
        v-btn(v-if="company.status === 'Trial'" color='white' text @click="dialog = false")
          .button-Aa-medium.primary400--text {{ $t('card_actions.close') }}

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { setOptions, bootstrap } from 'vue-gtag'
import CardList from '@/components/billing/CardList.vue'
import FPXPicker from '@/components/FPXPicker.vue'
import SubscribeLaterModal from './SubscribeLaterModal'
import EditMemberModal from './EditMemberModal'
import EditFormModal from './EditFormModal'
import Cookies from 'js-cookie'

export default {
  name: "SubscribeModal",
  components: { SubscribeLaterModal, CardList, EditMemberModal, EditFormModal, FPXPicker },
  props: ['open', 'company', 'volunteer', 'offer', 'paymentCallback'],
  data: (v) => ({
    metrics: null,
    subscribeLater: false,
    openEditMemberDialog: false,
    openEditFormDialog: false,
    selectedCommitmentType: 1,
    recommendedPlanIndex: 0,
    selected: true,
    step: 0,
    steps: [
      { title: v.volunteer ? 'Yezza Subscription' : 'Trial has ended', hidden: true},
      { title: 'Select plan', hidden: false},
      { title: 'Payment', hidden: false},
      { title: 'Confirmation', hidden: false},
      { title: 'Subscription Successful!', hidden: true},
      { title: 'Payment Unsuccessful', hidden: true}
    ],
    plans: [
      { name: 'Free', value: 4, detail: { form: '1 form', member: '1 salesperson' }, form_count: 1, member_count: 1, max: { member: null, form: null }, selected: false, plan: 'YZ_FREE_V2_PLAN', promo_code_yearly: null, promo_code_monthly: null, yezza_pay_rate: '2.9' },
      { name: 'Start', value: 2, detail: { form: '3 forms', member: '3 salesperson' }, form_count: 3, member_count: 3, max: { member: null, form: null }, selected: false, plan: 'YZ_START_PLAN', promo_code_yearly: null, promo_code_monthly: null, yezza_pay_rate: '0' },
      { name: 'Growth', value: 3, detail: { form: '10 forms', member: '10 salesperson' }, form_count: 10, member_count: 10, max: { member: null, form: null }, selected: false, plan: 'YZ_GROWTH_PLAN', promo_code_yearly: null, promo_code_monthly: null, yezza_pay_rate: '0' }
    ],
    selectedPlan: null,
    commitments: [
      { text: 'Yearly contract', value: 'yearly' },
      { text: 'Monthly contract', value: 'monthly' }
    ],
    form: {
      company: v.company.id,
      plan: null,
      contract: null,
      commitment: 'monthly',
      billing_cycle: 'yearly',
      card: null
    },
    planGroup: null,
    formAddOnCount: 0,
    memberAddOnCount: 0,
    isLoading: false,
    selectedPaymentMethod: null,
    fpxBankCode: null,
    retryPaymentLoading: false
  }),
  computed: {
    ...mapState('subscriptions', ['yezzaTrial']),
    authMember () {
      return this.$store.state.user.member
    },
    dialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    totalAllowedMember () {
      return this.selectedPlan.member_count + this.memberAddOnCount
    },
    isValidMemberCount () {
      if (this.company.active_member_count > this.totalAllowedMember) {
        return false
      }
      return true
    },
    totalAllowedForm () {
      return this.selectedPlan.form_count + this.formAddOnCount
    },
    isValidFormCount () {
      if (this.selectedPlan.name == 'Intelligence' || this.selectedPlan.name == 'Growth' ) {
        return true
      }
      if (this.company.published_form_count > this.totalAllowedForm) {
        return false
      }
      return true
    },
    extraPrice () {
      let totalPrice = 0
      if (this.formAddOnCount) {
        totalPrice += this.formAddOnCount * this.selectedPlan.addon_price[this.form.commitment].form[this.$currency.code]
      }
      if (this.memberAddOnCount) {
        totalPrice += this.memberAddOnCount * this.selectedPlan.addon_price[this.form.commitment].member[this.$currency.code]
      }
      return totalPrice
    },
    totalPrice () {
      if (!this.selectedPlan) return 0
      if (this.selectedPlan.value === 4) {
        return '0'
      }
      let basePrice = this.selectedPlan.price.monthly[this.$currency.code]
      if (this.form.commitment == 'yearly') {
        basePrice = this.selectedPlan.price.yearly[this.$currency.code]
      }
      return basePrice
    },
    totalPriceAmount () {
      if (!this.selectedPlan) return 0
      let totalPrice = this.extraPrice
      if (this.selectedPlan.value !== 4) {
        if (this.form.commitment == 'yearly') {
          totalPrice += this.selectedPlan.price.yearly[this.$currency.code]
        } else {
          totalPrice += this.selectedPlan.price.monthly[this.$currency.code]
        }
      }
      return totalPrice
    },
    formItems () {
      if (!this.selectedPlan) return []
      if (this.selectedPlan.name == 'Free') {
        return []
      } else if (this.selectedPlan.name == 'Business') {
        return []
      }
      return []
    },
    memberItems () {
      if (!this.selectedPlan) return []
      if (this.selectedPlan.name == 'Free') {
        return []
      } else if (this.selectedPlan.name == 'Business') {
        return []
      }
      return []
    },
    windowTitle () {
      return this.steps[this.step].title
    },
    currentProgress () {
      return Math.ceil((this.step / this.steps.length) * 100)
    }
  },
  watch: {
    selectedCommitmentType (val) {
      // Set to Personal (normal) when changed to yearly contract
      if (val === 0 && this.selectedPlan.value === 4) {
        this.selectPlan(this.plans[1])
      }
      if (val === 1 && this.selectedPaymentMethod == 'fpx') {
        this.selectedPaymentMethod = 'card'
      }
      this.setCommitment(val)
    },
    'form.billing_cycle' (val) {
      if (val === 'monthly' && this.selectedPaymentMethod == 'fpx') {
        this.selectedPaymentMethod = 'card'
      }
    }
  },
  mounted () {
    this.fetchCompany()
    this.fetchMetrics()
    this.fetchPlanGroups()
    if (this.paymentCallback) {
      if (this.paymentCallback.success) {
        this.step = 4
      } else {
        this.step = 5
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage',
      'updateCompany'
    ]),
    fetchCompany () {
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        this.$axios.get(`/companies/${this.company.id}/`)
          .then(resp => {
            this.updateCompany(resp.data)
          })
          .catch(() => {})
      } else {
        this.$axios.get(`/companies/${this.$subdomain}/`, { params: { use_slug: 'true' } })
          .then(resp => {
            this.updateCompany(resp.data)
          })
          .catch(() => {})
      }
    },
    fetchMetrics () {
      this.$axios.get(`/companies/${this.company.id}/sales/`)
        .then(resp => {
          this.metrics = resp.data
        })
        .catch(() => {})
    },
    fetchPlanGroups () {
      this.$axios.get(`/subscription/plan_groups/YEZZA`)
        .then(resp => {
          this.planGroup = resp.data
          this.plans.forEach(o => {
            let plan = resp.data.plans.find(f => f.code === o.plan)
            if (plan) {
              let monthly = plan.contracts.find(f => f.billing_cycle === 'monthly')
              let yearly = plan.contracts.find(f => f.billing_cycle === 'yearly')
              let price = {
                monthly: monthly?.prices || null,
                yearly: yearly?.prices || null
              }
              let slash_price = {
                monthly: monthly?.compare_at_prices && Object.keys(monthly?.compare_at_prices).length > 0 ?  monthly.compare_at_prices : null,
                yearly: yearly?.compare_at_prices && Object.keys(yearly?.compare_at_prices).length > 0 ? yearly.compare_at_prices : null
              }
              let form_monthly = monthly?.add_ons.find(f => f.feature.code === 'YZ_FORM')
              let member_monthly = monthly?.add_ons.find(f => f.feature.code === 'YZ_MEMBER')
              let form_yearly = yearly?.add_ons.find(f => f.feature.code === 'YZ_FORM')
              let member_yearly = yearly?.add_ons.find(f => f.feature.code === 'YZ_MEMBER')
              let addon_price = {
                monthly: {
                  form: form_monthly?.prices || null,
                  member: member_monthly?.prices || null
                },
                yearly: {
                  form: form_yearly?.prices || null,
                  member: member_yearly?.prices || null
                },
              }
              this.$set(o, 'price', price)
              this.$set(o, 'slash_price', slash_price)
              this.$set(o, 'addon_price', addon_price)
            }
          })
          this.selectingPlan()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    selectingPlan () {
      let index = 1
      if (this.company.published_form_count > this.plans[0].form_count) {
        index = 1
      }
      if (this.company.published_form_count > this.plans[1].form_count) {
        index = 2
      }
      if (this.company.active_member_count > this.plans[0].member_count) {
        index = 1
      }
      if (this.company.active_member_count > this.plans[1].member_count) {
        index = 2
      }
      this.plans[index].selected = true
      this.selectedPlan = this.plans[index]
      if (this.company.published_form_count - this.selectedPlan.form_count > 0) {
        this.formAddOnCount = this.company.published_form_count - this.selectedPlan.form_count
      }
      if (this.company.active_member_count - this.selectedPlan.member_count > 0) {
        this.memberAddOnCount = this.company.active_member_count - this.selectedPlan.member_count
      }
      this.recommendedPlanIndex = index
    },
    updatePlanValue (index, value) {
      this.plans[index].value = value
      if (this.selectedPlan.name === 'Free') {
        this.selectedPlan.value = value
      }
    },
    setCommitment (index) {
      const selected = this.commitments[index]
      this.form.commitment = selected.value
    },
    selectPlan(plan) {
      this.plans.forEach(p => {
        if (p.value === plan.value) {
          p.selected = true
          this.selectedPlan = p
        } else {
          p.selected = false
        }
      })
    },
    nextStep () {
      if (this.step === 1) {
        if (!this.isValidMemberCount) {
          this.showMessage(['error', this.$t('error_message.exceeded_member_count')])
          this.openEditMemberDialog = true
          return
        }
        if (!this.isValidFormCount) {
          this.showMessage(['error', this.$t('error_message.exceeded_form_count')])
          this.openEditFormDialog = true
          return
        }
      }

      if (this.step === this.steps.length - 1) return

      if (this.step === 3) {
        let contract = this.planGroup.plans.filter(p => p.code === this.selectedPlan.plan)[0].contracts.filter(p => p.code === `${this.selectedPlan.plan}${this.form.commitment === 'monthly' ? '_MM' : this.form.billing_cycle === 'monthly' ? '_YM' : '_YY'}`)[0]
        if (!contract) {
          contract = this.planGroup.plans.filter(p => p.code === this.selectedPlan.plan)[0].contracts.filter(p => p.code === `${this.selectedPlan.plan}`)[0]
        }
        if (!contract) {
          this.showMessage(['error', this.$t('error_message.invalid_plan')])
          return
        }

        this.form.contract = contract.code
        this.form.add_ons = []
        const formItem = {
          feature: 'YZ_FORM',
          count: this.formAddOnCount
        }
        this.form.add_ons.push(formItem)
        const memberItem = {
          feature: 'YZ_MEMBER',
          count: this.memberAddOnCount
        }
        this.form.add_ons.push(memberItem)
        this.isLoading = true
        this.$axios.post(`/subscription/subscriptions/${this.yezzaTrial.data.id}/cancel/`, {})
          .catch(() => {})
          .finally(() => {
            if (this.selectedPaymentMethod === 'card') {
              this.subscribeByCard()
            } else if (this.selectedPaymentMethod === 'fpx') {
              this.subscribeByFpx()
            }
          })
      } else {
        this.step++
        if (this.step === 2) {
          this.printSelection()
        }
      }
      if (!this.planGroup) {
        this.fetchPlanGroups()
      }
    },
    subscribeByCard () {
      this.isLoading = true
      this.form.fbq = {
        cookies: Cookies.get(),
        user_agent: navigator.userAgent
      }
      this.$axios.post(`/subscription/subscriptions/`, this.form)
        .then(resp => {
          this.$axios.post(`/subscription/bills/${resp.data.bill}/charge_card/`, this.form)
            .then(() => {
              this.$emit('subscribed')
              this.fetchCompany()
              this.step++
              this.trackGtag()
              this.trackPixel()
              this.trackTikTok()
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_subscribe_card')])
            })
            .finally(() => {
              this.isLoading = false
            })
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_subscribe_card')])
          this.isLoading = false
        })
    },
    subscribeByFpx () {
      this.isLoading = true
      if (this.company.currency.currency_code === 'IDR') {
        this.form.method = 'xendit'
      } else {
        this.form.method = 'laravel'
      }
      this.form.bank_code = this.fpxBankCode
      this.form.fbq = {
        cookies: Cookies.get(),
        user_agent: navigator.userAgent
      }
      this.$axios.post(`/subscription/subscriptions/`, this.form)
        .then(resp => {
          this.$axios.post(`/subscription/bills/${resp.data.bill}/request_manual_payment/`, this.form)
            .then(resp => {
              const data = resp.data
              console.log(data)
              setTimeout(() => {
                location.href = data.bill_url
              }, 1000)
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_subscribe_method')])
              this.isLoading = false
            })
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_subscribe_method')])
          this.isLoading = false
        })
    },
    retryPayment () {
      this.retryPaymentLoading = true
      location.href = `${process.env.VUE_APP_BILLPLZ_URL}/bills/${this.paymentCallback.billId}?auto_submit=true`
    },
    trackGtag () {
      setOptions({
        config: { id: process.env.VUE_APP_YEZZA_GTAG_ID }
      })
      bootstrap().then(() => {
        this.$gtag.linker({
          'domains': ['yezza.com', 'yezza.io']
        })
        this.$gtag.purchase({
          'value': this.totalPriceAmount
        })
      })
    },
    trackTikTok (){
      window.ttq.load('CHCSTS3C77U8J3S3PK50')
      window.ttq.track('Subscribe')
    },
    trackPixel (eventID) {
      window.fbq('trackSingle', process.env.VUE_APP_YEZZA_FB_PIXEL_ID, 'Subscribe', {
        value: this.totalPriceAmount/this.$currency.multiplier,
        currency: this.$currency.code
      }, {eventID: eventID})
    },
    printSelection () {
      console.log(`Selected plan: ${this.selectedPlan.value}`)
    },
    gotoHome () {
      document.location.href = '/admin/dashboard'
    }
  }
}
</script>

<style lang="scss" scoped>
.colbox {
  border: 1px solid var(--v-primary400);
  background-color: var(--v-basic200);
  border-radius: 5px;
  text-align: center;
  padding-top: 3px;
  margin-left: 4px;
  margin-right: 4px;
  height: 32px;
  width: 60px;
}

.slash-price {
  display: inline-block;
  text-decoration: none;
  position: relative;
}
.slash-price:after {
  content: '';
  display: block;
  width: 100%;
  height: 52%;
  position: absolute;
  top: 0;
  left: 0;
  border-bottom: 2px solid;
}

.v-card.payment-method-selected {
  border-color: #D11184;
}

.main-container {
  position: relative;
}

.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
</style>

<i18n>
{
  "en": {
    "account_suspended": "Account Suspended",
    "subscription": "Yezza Subscription",
    "step_0": {
      "text_1": "To date, you have made",
      "text_2": "using Yezza. How about going bigger with us?",
      "text_3": "Siapa kata berniaga pakai whatsapp tak canggih? :)",
      "contact_admin": "Please contact your admin and notify them to renew subscription."
    },
    "step_1": {
      "current_account": "Your current account",
      "members": "active salespersons / agents",
      "forms": "published forms",
      "manage_button": "Manage",
      "yearly_contract": "Yearly contract",
      "monthly_contract": "Monthly contract",
      "price_offer": "Get this yearly contract price of {text} for 3 months",
      "yearly_offer": "2 Months Free",
      "monthly_offer": "Grab Discount Now!",
      "follow_up_system": "Follow-up System",
      "boost_sales": "( Recommended to Boost your Sales )",
      "add_ons": "Add-ons",
      "form": "Form",
      "salesperson": "Salesperson",
      "each_month": "each/month",
      "each_year": "each/year",
      "agent_commission_system": "Agent Commission System",
      "product_bundle_offer": "Product Bundle Offer"
    },
    "step_2": {
      "select_payment_method": "Select payment method",
      "card": "Credit or debit card",
      "online": "Online banking",
      "yearly_contract": "For yearly contract only",
      "annual_billing": "For annual billing only",
      "choose_bank": "Choose bank for payment"
    },
    "step_3": {
      "confirm_subscribe": "Confirm your subscription",
      "plan": "Plan",
      "price_month": "per month with monthly contract",
      "price_year": "per {text} with yearly contract",
      "transacton": "of transaction",
      "extra_form": "extra form | extra forms",
      "extra_member": "extra member | extra members"
    },
    "step_4": {
      "subscribe_successful": "Subscription successful!",
      "thanks": "Thank you for giving us the opportunity to help you grow further and bigger.",
      "thanks_2": "Let’s do this together.",
      "finish_button": "FINISH"
    },
    "step_5": {
      "payment_failed": "Payment failed",
      "try_again": "The payment did not go through, please try again.",
      "retry_button": "Retry Payment"
    },
    "card_actions": {
      "selected_plan": "Selected plan:",
      "contract": "contract",
      "service_fee": "Service Fee (% of transaction)",
      "forms": "forms ({text} add-ons)",
      "salespersons": "salespersons ({text} add-ons)",
      "manage_account": "Manage your account or select add-ons to fit this plan",
      "subscrbe_later": "Subscribe later",
      "back": "Back",
      "next": "Next",
      "confirm_pay": "Confirm and pay",
      "close": "Close"
    }
  },
  "id": {
    "account_suspended": "Akun Ditangguhkan",
    "subscription": "Berlangganan Yezza",
    "step_0": {
      "text_1": "Sampai saat ini, kamu telah membuat",
      "text_2": "menggunakan Yezza. Bagaimana kalau menjadi lebih besar bersama kami?",
      "text_3": "Siapa kata berniaga pakai whatsapp tak canggih? :)",
      "contact_admin": "Silakan hubungi admin kamu dan beri tahu mereka untuk memperbarui langganan."
    },
    "step_1": {
      "current_account": "Akun kamu saat ini",
      "members": "salespersons / agents aktif",
      "forms": "form yang dipublikasikan",
      "manage_button": "Kelola",
      "yearly_contract": "paket tahunan",
      "monthly_contract": "paket bulanan",
      "price_offer": "Dapatkan harga paket tahunan sebesar {text} selama 3 bulan",
      "yearly_offer": "2 bulan GRATIS",
      "monthly_offer": "[Grab Now] Diskon",
      "follow_up_system": "Sistem Follow-up",
      "boost_sales": "( Direkomendasikan untuk Meningkatkan Penjualan kamu )",
      "add_ons": "Add-ons",
      "form": "form",
      "salesperson": "Salesperson",
      "each_month": "setiap bulan",
      "each_year": "setiap tahun",
      "agent_commission_system": "Sistem Komisi Agen",
      "product_bundle_offer": "Penawaran Paket Produk"
    },
    "step_2": {
      "select_payment_method": "Pilih metode pembayaran",
      "card": "Kartu kredit atau debit",
      "online": "Perbankan Online",
      "yearly_contract": "Hanya untuk paket tahunan",
      "annual_billing": "Hanya untuk tagihan tahunan",
      "choose_bank": "Pilih bank untuk pembayaran"
    },
    "step_3": {
      "confirm_subscribe": "Konfirmasi langganan kamu",
      "plan": "Plan",
      "price_month": "per bulan dengan paket bulanan",
      "price_year": "per {text} dengan paket tahunan",
      "transacton": "dari transaksi",
      "extra_form": "form tambahan | form tambahan",
      "extra_member": "member tambahan | member tambahan"
    },
    "step_4": {
      "subscribe_successful": "Berlangganan berhasil!",
      "thanks": "Terima kasih telah memberi kami kesempatan untuk membantu kamu tumbuh lebih jauh dan lebih besar.",
      "thanks_2": "Mari kita lakukan ini bersama.",
      "finish_button": "SELESAI"
    },
    "step_5": {
      "payment_failed": "Pembayaran gagal",
      "try_again": "Pembayaran tidak berhasil, silakan coba lagi.",
      "retry_button": "Coba lagi"
    },
    "card_actions": {
      "selected_plan": "Paket yang dipilih:",
      "contract": "kontrak",
      "service_fee": "Fee Servis (% dari transaksi)",
      "forms": "forms ({text} add-ons)",
      "salespersons": "salespersons ({text} add-ons)",
      "manage_account": "Kelola akun kamu atau pilih add-on agar sesuai dengan paket ini",
      "subscrbe_later": "Berlangganan nanti",
      "back": "Kembali",
      "next": "Berikutnya",
      "confirm_pay": "Konfirmasi dan bayar",
      "close": "Tutup"
    }
  }
}
</i18n>
